import $ from 'jquery';
import processInclude from './util';
import * as productTileWishlist from './wishlist/productTile';

import '~base';

$(document).ready(() => {
  processInclude(productTileWishlist);
});
